import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  Select,
  MenuItem,
  Link,
  Tooltip,
  Typography,
  Hidden,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Logo from 'src/components/Logo';
import Flag from 'src/components/Flag';
import useAuth from 'src/hooks/useAuth';
import Auth0Login from './Auth0Login';
import FirebaseAuthLogin from './FirebaseAuthLogin';
import JWTLogin from './JWTLogin';
import { CenterFocusStrong } from '@material-ui/icons';

const methodIcons = {
  'Auth0': '/static/images/auth0.svg',
  'FirebaseAuth': '/static/images/firebase.svg',
  'JWT': '/static/images/jwt.svg'
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.light,
    display: 'flex',
    flexDirection: 'column',
    // minHeight: '100vh'
  },
  banner: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    // borderBottom: `1px solid ${theme.palette.divider}`
  },
  headingBold1: {
    //styleName: Heading / Bold / 1
    fontFamily: 'Roboto',
    fontSize: 40,
    fontStyle: 'normal',
    fontWeight: 700,
    // lineHeight: 38,
    letterSpacing: 0,
    textAlign: 'center',
    color: '#353535'
  },
  bannerChip: {
    marginRight: theme.spacing(2)
  },
  methodIcon: {
    height: 30,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  cardContainer: {

    paddingBottom: 80,
    paddingTop: 80,
  },
  cardTitle1: {
    fontFamily: 'Montserrat',
    color: theme.palette.primary.main,
    fontStyle: 'normal',
    fontSize: '46px',
    lineHeight: '55px',
  },
  cardTitle2: {
    fontFamily: 'Montserrat',
    color: theme.palette.primary.main,
    fontStyle: 'normal',
    fontSize: '28px',
    lineHeight: '55px',
  },
  cardTitleSub: {
    fontFamily: 'Montserrat',
    color: theme.palette.primary.main,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '17px',
  },
  cardText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '20px',
    color: 'rgba(24, 24, 25, 0.6)',
    lineHeight: '24px',
    textAlign: 'center'
  },
  createAccount1: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: 'rgba(24, 24, 25, 0.6)',
    lineHeight: '24px',
    // textAlign: 'center',
    marginRight: '5px'
  },
  createAccount2: {
    fontFamily: 'Roboto',
    color: theme.palette.primary.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    // textAlign: 'center'
  },
  cardContent: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    minHeight: 400,
  },
  currentMethodIcon: {
    height: 40,
    '& > img': {
      width: 'auto',
      maxHeight: '100%'
    }
  },
  footerBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    bottom: '16px',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: 'rgba(24, 24, 25, 0.6)',
    paddingTop: '30px'
  }
}));

const LoginView = () => {
  const classes = useStyles();
  const { method } = useAuth();

  return (
    <Page
      className={classes.root}
      title="Login"
    >
      <div className={classes.banner}>
        <Container maxWidth="md">
          <Hidden mdDown>
            <Box mx={5} />
          </Hidden>
          <Box
            alignItems="center"
            display="flex"
            justifyContent="flex-end"
          >
            {/* <Select
              variant="standard"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              disableUnderline
              defaultValue="ENG"
            >
              <MenuItem value='ENG'>
                  <RouterLink to="/eng" >
                    <Flag className={classes.logo} lang="eng" />
                  </RouterLink>
              </MenuItem>
              <MenuItem value='KOR'>
                  <RouterLink to="/kor" >
                    <Flag className={classes.logo} lang="kor" />
                  </RouterLink>
              </MenuItem>
            </Select> */}
          </Box>
          <Hidden mdDown>
            <Box mx={5} />
          </Hidden>
        </Container>
      </div>
      <Container
        className={classes.cardContainer}
        maxWidth="sm"
      >
        <Box
          mb={8}
          display="flex"
          justifyContent="center"
        >
        
        </Box>
        <Card style={{ border: "none", boxShadow: "none" }}>
          <CardContent className={classes.cardContent}>
            <Box
              alignItems="center"
              display="flex"
              justifyContent="center"
              mb={3}
            >
              <Box>
                <Typography className={classes.headingBold1}>
                  Oneword Admin
                </Typography>
              </Box>
              {/* <div className={classes.currentMethodIcon}>
                <img
                  alt="Auth method"
                  src={methodIcons[method]}
                />
              </div> */}
            </Box>
            
            <Box
              flexGrow={1}
              mt={3}
            >
              {method === 'Auth0' && <Auth0Login /> }
              {method === 'FirebaseAuth' && <FirebaseAuthLogin /> }
              {method === 'JWT' && <JWTLogin /> }
            </Box>
            {/* <Box my={3}>
              <Divider />
            </Box> */}
            {/* <Box style={{textAlign: 'center'}}>
              <span className={classes.createAccount1}>
                Don’t have an account yet?
              </span>
              <RouterLink 
                to='/register'
                style={{textDecoration: 'none'}}>
              <span className={classes.createAccount2}>
                Create an account
              </span>
              </RouterLink>
            </Box> */}
          </CardContent>

        </Card>
      </Container>
      <Box className={classes.footerBox}>
        <Typography>
        © SOTHECODE CORP. ALL RIGHTS RESERVED.
        </Typography>
      </Box>
    </Page>
  );
};

export default LoginView;
